import React, { useContext } from 'react'
// eslint-disable-next-line no-unused-vars
import { IInputOnChange, Input } from '@desenvolvimento-intuix/ui-form'

import { Container } from './styles'
import { PaginateContext } from '../../contexts/paginate'
import { SearchContext } from '../../contexts/search'

export const Search: React.FC = () => {
  const { search, setSearch } = useContext(SearchContext)

  const { setPage } = useContext(PaginateContext)

  const onChange: IInputOnChange = (_name, value) => {
    setSearch(value)

    setPage(0)
  }

  return (
    <Container className='table-search'>
      <Input
        {...{
          type: 'search',
          value: search,
          onChange
        }}
      />
    </Container>
  )
}
